import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const BytesConverter = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [val, setVal] = useState('1024');
  const [unit, setUnit] = useState('KB');
  const [res, setRes] = useState<any>(null);

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const factors: any = { Bytes: 1, KB: 1024, MB: 1024 ** 2, GB: 1024 ** 3, TB: 1024 ** 4 };

  const calculate = () => {
    const bytes = parseFloat(val) * (factors[unit] || 1);
    const results: any = {};
    units.forEach(u => results[u] = (bytes / factors[u]).toFixed(2));
    setRes(results);
    onResultChange(units.map(u => ({ label: u, value: results[u] })));
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Valor" value={val} onChange={setVal} isNumeric required />
          <FormField label="Unidade" value={unit} onChange={setUnit} type="select" options={units.map(u => ({ value: u, label: u }))} />
        </div>
        <div className="flex justify-center mb-6">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold">Converter</button>
        </div>
        {res && (
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {units.map(u => <ResultCard key={u} title={u} value={res[u]} color="blue" />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default BytesConverter;
